<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import '@/css/main.scss'

export default {
  name: "App",
  created () {
    // 调试模式检测
    const debug = this.$global.GetQueryString('db');
    if (debug) {
      this.$store.commit('setDebug', true);
    }

    // 设备类型检测和存储
    const deviceType = this.detectDeviceType();
    this.$store.commit('setDeviceType', deviceType);

  },
  mounted () {
    // 获取TV类型列表并存储
    this.fetchTvGenres();
    this.fetchMovieGenres();
  },
  methods: {
    detectDeviceType () {
      try {
        // SSR 环境检测
        if (typeof this.$ssrContext !== 'undefined' && this.$ssrContext.device) {
          return this.$ssrContext.device;
        }

        // 客户端环境检测
        if (typeof window !== 'undefined') {
          const userAgent = navigator.userAgent.toLowerCase();

          // 平板设备检测
          const isTablet = /ipad|tablet|(android(?!.*mobile))/i.test(userAgent);
          if (isTablet) return 'tablet';

          // 移动设备检测
          const isMobile = /mobile|android|iphone|phone|webos|ipod|blackberry|windows phone/i.test(userAgent);
          if (isMobile) return 'mobile';

          // 增加触摸设备检测作为辅助判断
          const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
          if (hasTouch && window.innerWidth < 768) return 'mobile';
        }

        return 'desktop';
      } catch (error) {
        console.warn('设备类型检测失败:', error);
        return 'desktop'; // 发生错误时返回默认值
      }
    },

    // 获取TV类型列表
    fetchTvGenres () {
      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: {
          language: 'en',
        },
        url: '/3/genre/tv/list',
      })
        .then(response => {
          if (response && response.genres) {
            this.$store.commit('setTvGenres', response.genres);
            console.log('TV类型列表获取成功:', response.genres);
          }
        })
        .catch(error => {
          console.error('获取TV类型列表失败:', error);
        });
    },
    // 获取Movie类型列表
    fetchMovieGenres () {
      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: {
          language: 'en',
        },
        url: '/3/genre/movie/list',
      })
        .then(response => {
          if (response && response.genres) {
            this.$store.commit('setMovieGenres', response.genres);
            console.log('movie类型列表获取成功:', response.genres);
          }
        })
        .catch(error => {
          console.error('获取movie类型列表失败:', error);
        });
    }
  }
};
</script>
